export default {
  REQUIRED: 'This field is required',
  SHOULD_BE_A_NUMBER: 'This field should be a valid number',
  SHOULD_BE_POSITIVE: 'Should be a positive number',
  INVALID_EMAIL: 'Email is invalid',
  INVALID_ZIP: 'Zip code is invalid',
  INVALID_PHONE: 'Phone is invalid',
  INVALID_URL: 'Url is invalid',
  ICC_GET_STARTED_TEXT:
    'Enter this setup token into the Paperless Parts Cloud Connector running within your firewall.',
  ICC_TOKEN_NEEDED_TEXT:
    'A new Setup Token will need to be generated.  The previous one is no longer valid.  Please contact Paperless Parts Support for assistance.',
};
